import Vue from 'vue'
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import messages from '@/locales/locales.js'
import dateTimeFormats from '@/locales/dateTimeFormats.js'
import numberFormats from '@/locales/numberFormats.js'

let locale = navigator.language
// Keeps only major language
locale = locale.substring(0,2);

export default new VueI18n({
  fallbackLocale: 'en',
  locale: locale,
  messages,
  dateTimeFormats,
  numberFormats,
});
